import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
};

const SidebarDrawer = ({ isOpen, onClose, children }: Props) => (
  <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
    <DrawerOverlay />
    <DrawerContent>
      <DrawerCloseButton color="white" />
      <DrawerBody bg="matisseBlue" overflowY="auto" overflowX="hidden">
        {children}
      </DrawerBody>
    </DrawerContent>
  </Drawer>
);

export default SidebarDrawer;
